import { SubmitGroupItemModel, TextInputModel } from '@libs/form/models';

export const dialogTitleNew: string = 'Neue Einkaufsliste';
export const dialogTitleEdit: string = 'Einkaufsliste umbenennen';

export const nameFieldData: TextInputModel = {
  type: 'text',
  name: 'name',
  label: 'Listenname',
  hint: '*Pflichtfeld',
  attributes: {
    required: true,
  },
};

export const createSubmitItemData: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'cancel',
      label: 'Abbrechen',
      theme: 'text',
    },
    {
      name: 'submit',
      label: 'Erstellen',
      theme: 'filled',
    },
  ],
};

export const editSubmitItemData: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'cancel',
      label: 'Abbrechen',
      theme: 'text',
    },
    {
      name: 'submit',
      label: 'Speichern',
      theme: 'filled',
    },
  ],
};
